import httpClient from "./httpClient";

export async function listarMotivosTarefa() {
  const resp = await httpClient.get("/api/motivos");
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function criarMotivoTarefa(motivo) {
  const resp = await httpClient.post("/api/motivos", motivo);
  return resp.data;
}

export async function atualizarMotivoTarefa(id, motivo) {
  const resp = await httpClient.put(`/api/motivos/${id}`, motivo);
  return resp.data;
}

export async function removerMotivoTarefa(id) {
  await httpClient.delete(`/api/motivos/${id}`);
}
